export default "__VITE_ASSET__UNTv9f0K__"